import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { map, shareReplay, switchMap } from 'rxjs/operators';
import { OrderformFascade } from '../../fascades/orderform.fascade';
import { isPageBuilderDesignMode } from '../../misc/pagebuilder';
import {
  INFO_TEXT_WIDGET_DISPLAY,
  InputsGeneratorComponent,
} from '../inputs-generator/inputs-generator.component';
import { FormFields } from '@orderform/widgets';
import { Observable, of, Subject } from 'rxjs';

@Component({
  selector: 'orderform-input-checkboxes',
  templateUrl: './input-checkboxes.component.html',
  styleUrls: ['./input-checkboxes.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputCheckboxesComponent
  implements OnInit, OnDestroy, AfterViewChecked
{
  infoText = INFO_TEXT_WIDGET_DISPLAY;

  order$ = this._orderformFascade.order$;

  isDesignMode = isPageBuilderDesignMode();

  filledCheckboxes$ = this.order$.pipe(
    map((order) => order.order.checkboxes),
    shareReplay(1)
  );

  checkboxes$: Observable<FormFields.Field[]> =
    this._orderformFascade.settings$.pipe(
      map((settings) => settings.checkboxes),
      shareReplay(1)
    );

  private _afterViewChecked$ = new Subject<void>();

  @ViewChild('fieldInput', { static: false })
  fieldInput: InputsGeneratorComponent;
  @Output() readonly validate = new EventEmitter<{
    valid: boolean;
    source: 'change' | 'submit';
  }>();

  private _formValidationSubscription = this._afterViewChecked$
    .pipe(
      switchMap(() =>
        this.fieldInput
          ? this.fieldInput.stateChange.pipe(
              map(() => this.fieldInput.isValid())
            )
          : of(true)
      )
    )
    .subscribe((valid) => this.validate.emit({ valid, source: 'change' }));

  private _submitFailedSubscription =
    this._orderformFascade.submitFailed.subscribe(() => {
      const valid = this.fieldInput ? this.fieldInput.isValid() : true;
      this.validate.emit({ valid, source: 'submit' });
    });

  constructor(private _orderformFascade: OrderformFascade) {}

  ngOnInit(): void {}

  setData(value) {
    return this._orderformFascade.setOrderStore({
      checkboxes: value,
    });
  }

  ngOnDestroy() {
    this._formValidationSubscription.unsubscribe();
    this._submitFailedSubscription.unsubscribe();
  }

  ngAfterViewChecked() {
    this._afterViewChecked$.next();
  }
}
